import cx from "classnames";

import { Badge, Button, type ButtonProps } from "@icg360/design-system";

import { NotificationsDrawer } from "components/notifications/notifications-drawer/notification-drawer";

import { useNotifications } from "../context";
import styles from "./notifications-header-button.module.scss";

type NotificationsHeaderButtonProps = {
  buttonClassName?: string;
  appearance?: ButtonProps["appearance"];
  testId: string;
};

export const NotificationsHeaderButton = ({
  buttonClassName,
  appearance,
  testId,
}: NotificationsHeaderButtonProps) => {
  const { unread, openDrawer } = useNotifications();

  return (
    <>
      <div className={styles.bellButtonWrapper}>
        <Button
          icon="Bell"
          appearance={appearance}
          onPress={openDrawer}
          data-testid={testId}
          aria-label="View notifications"
          className={cx(buttonClassName, {
            [styles.notificationBell]: unread > 0,
          })}
        />
        {unread > 0 && (
          <div className={styles.notificationCount}>
            <Badge.Numeric number={unread} appearance="success" size="small" />
          </div>
        )}
      </div>
      <NotificationsDrawer />
    </>
  );
};
